import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './GamersSummary.css';
import { SocialUserAvatar } from "./SocialUserAvatar";
import { useNavigate } from "./Router";

const GamersSummary = () => {
  const [bingoPlayers, setBingoPlayers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBingoPlayers = async () => {
      try {
        const players = await sdk.models.BingoGame.getCurrentPlayer();
        setBingoPlayers(players);
      } catch (error) {
        console.error("Erreur lors de la récupération des joueurs de bingo", error);
      }
    };

    fetchBingoPlayers();
  }, []);

  if (bingoPlayers.length === 0) return;

  return (
    <div className="bingo-summary-box">
      <h2>Joueurs de Bingo</h2>
      <p>Voici la liste des joueurs actuellement inscrits au bingo :</p>
      <div className="players-list">
        {bingoPlayers.length > 0 ? (
          bingoPlayers.map((playerId) => (
            <div key={playerId} className="player-item">
              <SocialUserAvatar user_id={playerId} />
            </div>
          ))
        ) : (
          <p>Aucun joueur actuellement inscrit.</p>
        )}
      </div>
      <button className="btn btn-primary" onClick={() => navigate("/games/bingo")}>
        Aller au Bingo
      </button>
    </div>
  );
};

export { GamersSummary };
